import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { browserHistory } from 'react-router';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import NotificationService from '../../../core/services/NotificationService';

const SchoolClassList = (props) => {
  const handleCopyPlacementTestLink = (token) => {
    navigator.clipboard.writeText(
      `${window.location.origin.replace('admin', 'student')}/placement-register?token=${token}`
    );
    NotificationService.addNotification('Link copied to clipboard', 'success');
  };

  return (
    <Table
      fetching={props.fetching}
      columns={[
        {
          label: 'School',
          path: 'school.name',
        },
        {
          label: 'Class',
          path: 'name',
        },
        {
          label: 'Teacher',
          path: 'teacher.name',
        },
        {
          label: 'Number Students',
          path: 'studentCount',
        },
        {
          label: 'Start',
          path: 'start',
          render: (value) => value && moment(value).format('DD/MM/YYYY'),
        },
        {
          label: 'End',
          path: 'end',
          render: (value) => value && moment(value).format('DD/MM/YYYY'),
        },
        {
          label: 'Actions',
          path: 'action',
          width: '120px',
          render: (cell, row) =>
            localStorage.role !== 'TEACHER' && (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
                <Button icon="edit" onClick={() => browserHistory.push(`${props.baseUrl}/classes/${row.id}`)} />
                <Button
                  icon="copy"
                  disabled={!row.placementTestToken}
                  onClick={() => handleCopyPlacementTestLink(row.placementTestToken)}
                />
              </div>
            ),
        },
      ]}
      rows={props.classes}
      selectable
      onSelect={(row) => browserHistory.push(`${props.baseUrl}/classes/${row.id}/details`)}
      onChange={props.onChange}
      pagination={props.pagination}
    />
  );
};

SchoolClassList.propTypes = {
  classes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      school: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  baseUrl: PropTypes.string.isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  pagination: PropTypes.shape({}).isRequired,
};

export default SchoolClassList;
